import { useLocation } from 'react-router-dom';

import { DefaultTopbarSearch } from './DefaultTopbarSearch';

const TITLES: Record<string, string> = {
  '/webadmin/app/stock/platform-sales': 'Продажи платформ',
  '/webadmin/app/stock/sales-invoices': 'Фактуры',
  '/webadmin/app/stock/hot-reports': 'Отчёты горячего',
};

/**
 * Stock lists without a topbar search of their own: a wide screen keeps the default
 * field, a phone names the page instead of showing a field that searches nothing.
 */
export function StockTitledTopbarContent() {
  const { pathname } = useLocation();
  const title = TITLES[pathname.replace(/\/$/, '')];
  return (
    <>
      <div className="min-w-0 flex-1 max-sm:hidden">
        <DefaultTopbarSearch />
      </div>
      <span className="min-w-0 flex-1 truncate text-base font-semibold text-foreground sm:hidden">
        {title}
      </span>
    </>
  );
}
